import { TYPES } from './constants';

export function renderFallback(renderContext, node) {
  if (renderContext.mode === 'export') return;
  const { context } = renderContext;
  const { x = 0, y = 0, w = 80, h = 40 } = node;

  context.save();

  // 极简淡红色纯色填充
  context.globalAlpha = 1;
  context.fillStyle = 'rgba(255, 80, 80, 0.25)';
  context.fillRect(x, y, w, h);

  // 抽象符号：居中绘制一个红色感叹号圆圈
  const centerX = x + w / 2;
  const centerY = y + h / 2;
  const radius = Math.min(w, h) * 0.18;

  // 绘制圆圈
  context.beginPath();
  context.arc(centerX, centerY, radius, 0, 2 * Math.PI);
  context.fillStyle = 'rgba(255, 80, 80, 0.85)';
  context.shadowColor = 'rgba(255,80,80,0.25)';
  context.shadowBlur = 4;
  context.fill();
  context.shadowBlur = 0;

  // 绘制感叹号
  context.beginPath();
  context.font = `bold ${radius * 1.6}px Arial`;
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  context.fillStyle = '#fff';
  context.fillText('!', centerX, centerY + 1);

  context.restore();
}

const typeColors = {
  [TYPES.row]: 'rgba(255, 0,0, 0.8)',
  [TYPES.col]: 'rgba(0, 255,0, 0.8)',
  [TYPES.text]: 'rgba(0, 0,255, 0.8)',
};

export function renderDebug(renderContext, node) {
  const { context } = renderContext;
  const { x, y, w, h } = node;
  const debug = renderContext.debug;
  if (!debug) return;
  context.font = 'bold 22px Arial'; // 设置字体大小和样式
  context.fillStyle = 'rgba(255, 255, 255, 0.8)'; // 设置字体颜色
  context.fillText(node.id, x + 5, y + 22 * 1.35 - 5); // 在 rect 左上角绘制 name，稍微调整 y 坐标以避免重叠
  context.beginPath();
  context.rect(x, y, w, h);
  context.lineWidth = 4; // 使用 node 的 borderWidth 属性，如果没有则默认为 2
  context.strokeStyle = typeColors[node.type] || 'cyan'; // 使用 node 的 borderFill 属性，如果没有则默认为黑色
  context.closePath();
  context.stroke();
}
